import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location, NgClass } from '@angular/common';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import 'rxjs/add/operator/switchMap';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../services/role.service';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { UserUpdateDto } from '../../dto/userUpdate.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

  title_component: string;
  user: User;
  message: string;
  button_save_status: boolean;
  button_delete_status: boolean;
  listRole = [];
  modalRef: BsModalRef;
  loading = false;
  email_status: boolean;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private roleService: RoleService,
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private baseService: BaseService
  ) { }

  ngOnInit(): any {
    this.title_component = 'Editar Usuario';
    this.baseService.changedComponentName(this.title_component);

    this.user = {
      id: null,
      email: '',
      name: '',
      lastName: '',
      phone: '',
      dni: '',
      creationDate: null,
      status: null,
      creationUser: null,
      role: '',
      fullName: ''
    };

    const id = +this.route.snapshot.paramMap.get('id');

    this.getRoles();

    this.userService.getInfoDetail(id).subscribe(data => {
      this.button_save_status = true;
      this.button_delete_status = true;
      this.user = data;
      this.getSearchRol(this.user.role);
      this.email_status = false;
    });
  }

  getRoles(): any {
    this.roleService.getAll()
      .subscribe(data => {
        this.listRole.push({ value: '', desc: '-- SELECCIONE ROL --' });
        data.forEach((rol) => {
          this.listRole.push({ value: rol.id, desc: rol.name });
        });
      });
  }

  edit(value): any {
    this.loading = true;
    const message = 'Usuario actualizado con exito.';
    const id = value.id;
    const dto = new UserUpdateDto(value.role, value.email, value.name, value.lastName, value.phone, value.dni);

    this.userService.updateUser(id, dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.loading = false;
          this.showSuccess(message);
          this.router.navigate(['/dashboard/users']);
        }, 1000);
      }
    },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('Ocurrió un error:', err.error.message);
        } else {
          console.log('Backend devuelto código de estado: ', err.status);
          console.log('Response body:', err.error);
          if (err.status === 409) {
            setTimeout(() => {
              this.loading = false;
              this.showError(err.error.message);
              this.email_status = true;
            }, 1000);
          }
        }
      }
    );
  }

  delete(event, role, templateConfirm: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(templateConfirm, {class: 'modal-sm'});
  }

  private getSearchRol(roleInput): any {
    this.listRole.forEach((rol) => {
      if (rol.desc === roleInput) {
        this.user.role = `${rol.value}`;
      }
    });
  }

  goBack(event): any {
    this.location.back();
  }

  showSuccess(message: string): any {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string): any {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  confirm(): any {
    this.loading = true;
    this.message = 'Confirmed!';
    const id = this.user['id'];
    this.userService.deleteUser(id);
    this.modalRef.hide();

    const message = 'Se elimino con exito.';
    this.button_delete_status = false;
    setTimeout(() => {
      this.loading = false;
      this.showSuccess(message);
      this.router.navigate(['/dashboard/user/page']);
    }, 1000);
  }

  decline(): any {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/user/user-info.component.ts